class Sorting {
    constructor(item) {
        // Переменные
        this.element = item;
        this.list = this.element.querySelector('.js-sorting-list');
        this.wrapper = this.element.querySelector('.js-sorting-wrapper');
        this.filterBtn = this.element.querySelector('.js-sorting-filter-btn');
        this.filterPopup = document.querySelector('.js-sorting-filter-popup');

        // Функции
        this.setListeners();
    };

    setListeners() {
        this.list.addEventListener('click', () => {
            this.list.classList.toggle('is-open');

            if (this.wrapper.style.height == 'auto') {
                this.wrapper.style.height = `${this.wrapper.scrollHeight}px`;
            }

            anime({
                targets: this.wrapper,
                height: this.list.classList.contains('is-open') ? this.wrapper.scrollHeight : 0,
                duration: 500,
                easing: 'easeInOutCirc',
                complete: () => {
                    if (this.list.classList.contains('is-open')) {
                        this.wrapper.style.height = 'auto';
                    } else {
                        this.wrapper.style.removeProperty('height');
                    }
                }
            });
        });

        this.filterBtn.addEventListener('click', () => {
            this.filterPopup.classList.add('is-open');
        });

        this.filterPopup.addEventListener('click', (event) => {
            if (event.target == this.filterPopup) {
                this.filterPopup.classList.remove('is-open');
            }
        });
    }
};

document.querySelectorAll('.js-sorting').forEach((item) => new Sorting(item));
